import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import NavBar from './components/NavBar';
import HomePage from './pages/HomePage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import BreedsPage from './pages/BreedsPage';
import BreedDetailPage from './pages/BreedDetailPage';
import UploadPage from './pages/UploadPage';
import PupDetailPage from './pages/PupDetailPage';
import AboutPage from './pages/AboutPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import ResetPasswordPage from './pages/ResetPasswordPage';
import './App.css';

function PrivateRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated } = useAuth();
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Set a timeout to ensure we don't hang indefinitely if auth check fails
    const timer = setTimeout(() => {
      setAuthChecked(true);
    }, 1000);

    return () => clearTimeout(timer);
  }, [isAuthenticated]);

  // Only redirect if auth is false after we've given it time to check
  if (!authChecked && !isAuthenticated) {
    return <div className="text-center p-5">Loading...</div>;
  }

  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
}

function App() {
  return (
    <div className="App">
      <NavBar />
      <main className="container mt-5 pt-4">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password/:token" element={<ResetPasswordPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/breeds" element={<BreedsPage />} />
          <Route path="/breeds/:breedId" element={<BreedDetailPage />} />
          <Route path="/pups/:pupId" element={<PupDetailPage />} />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <ProfilePage />
              </PrivateRoute>
            }
          />
          <Route path="/users/:username" element={<ProfilePage />} />
          <Route
            path="/upload"
            element={
              <PrivateRoute>
                <UploadPage defaultMode="camera" />
              </PrivateRoute>
            }
          />
          <Route
            path="/upload/camera"
            element={
              <PrivateRoute>
                <UploadPage defaultMode="camera" />
              </PrivateRoute>
            }
          />
          <Route
            path="/upload/file"
            element={
              <PrivateRoute>
                <UploadPage defaultMode="upload" />
              </PrivateRoute>
            }
          />
        </Routes>
      </main>
    </div>
  );
}

export default App;
